import axios from "axios";

export const apiUrl = "/";

export const apiConfig = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

apiConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const requestUrl = error.config?.url || "";
    if (requestUrl.includes("api/chef/v1/chef/profile")) {
      return Promise.reject(error);
    }

    if (error.response && error.response.data && error.response.data.message) {
      console.error("Error:", error.response.data.message);
    } else {
      console.error("An error occurred:", error.message);
    }

    return Promise.reject(error);
  }
);
